module.exports = __webpack_public_path__ + "img/Baidu.0cbe352b.jpg";